import React from "react";
import "./About.scss";

const About = props => {
  return (
    <div className="about">
      <div className="about-content">
        <div className="box1"></div>
        <div className="box2">
          <h1>Välkommen till en personlig redovisningsbyrå</h1>
          <p>
            Är du i behov av professionell redovisning och bokföring för att
            underlätta ditt företagande? <br/><br/>EkonomiKonsult4U erbjuder tjänster inom
            bokföring och redovisning till företag, föreningar och
            privatpersoner. Vi är en liten och personlig redovisningsbyrå med hög
            servicenivå i Göteborg som skräddarsyr våra tjänster efter dina
            önskemål.
          </p>
          <a href="mailto:thomas@ekonomikonsult4you.se">Boka ett möte</a>
        </div>
        <img className="box3" src={props.image} alt="Två personer går igenom dokument vid ett skrivbord" />
      </div>
    </div>
  );
};

export default About;
